import { map, shareReplay } from 'rxjs/operators';
import { ApiClient } from './api.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
/**
 * Elenco ISTAT dei comuni italiani, per le tendine "Comune".
 *
 * Sono 7.894 record (~395KB, ~83KB gzip): si scaricano una volta sola per
 * sessione e si cercano in locale, così la tendina risponde senza chiamate di
 * rete a ogni tasto premuto. `shareReplay` fa sì che le successive aperture
 * della modale riusino la stessa risposta.
 */
export class ComuniService {
    constructor(http) {
        this.http = http;
        this.cache = null;
    }
    list() {
        if (!this.cache) {
            this.cache = this.http.get('comuni').pipe(map((res) => res.data.map((comune) => (Object.assign({}, comune, { etichetta: `${comune.nome} (${comune.provincia})` })))), shareReplay(1));
        }
        return this.cache;
    }
}
ComuniService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ComuniService_Factory() { return new ComuniService(i0.ɵɵinject(i1.ApiClient)); }, token: ComuniService, providedIn: "root" });
